import React from 'react'
import YachtSlider from './YachtSlider'
import BookNowButton from './BookNowButton'
import { CiClock1, CiLocationOn } from "react-icons/ci";
import { IoMdPeople,IoLogoWhatsapp } from "react-icons/io";
import { Link } from 'react-router-dom'

const YachtCard = ({ yacht, onOpenModal }) => {
    return (
        <>
            <div className="card h-100">
                <YachtSlider yachtImages={yacht.images} />
                <div className="card-body">
                    <h5 className="card-title">{yacht.yacht_name}</h5>
                    <hr />
                    {/* <div className="d-flex justify-content-between">
                        <h6>${yacht.price_details[0].price} / 2 Hours</h6>
                        <BookNowButton buttonText="BOOK NOW" buttonClass="book-btn" yachtId={yacht.id} yachtName={yacht.yacht_name} />
                    </div> */}
                    <div className='card-content' >
                        <CiClock1 className='icon' fontSize={22} />
                        <p className='my-auto ms-2'>1 Hour Price :  AED {yacht.price_details[0].price}</p>
                    </div>
                    <div className='card-content' >
                        <CiLocationOn className='icon' fontSize={22} />
                        <p className='my-auto ms-2'>Brand : {yacht.brand}</p>
                    </div>
                    <div className='card-content mb-4'>
                        <IoMdPeople className='icon' fontSize={22} />
                        <p className='my-auto ms-2'>Capacity : {yacht.passenger_capacity}</p>
                    </div>
                    <BookNowButton buttonText="Book Now" buttonClass="yacht-modal-book-btn" yachtId={yacht.id} yachtName={yacht.yacht_name} />
                    <Link to='https://api.whatsapp.com/send?phone=971566265785' className="whats-app-btn">
                        Book by <IoLogoWhatsapp />
                    </Link>
                    {/* <div className="d-md-flex justify-content-between mt-4">
                        <div className="d-flex">
                            <ul className="content">
                                <li>Location <br /> {yacht.location}</li>
                                <li>Capacity <br /> {yacht.passenger_capacity} Persons</li>
                            </ul>
                        </div>
                        <div className="d-flex" onClick={() => onOpenModal(yacht)} role="button">
                            <a>More <br className="d-md-block d-none" />
                                Details</a>
                            <img src="assets/images/next.png" alt="next-icon" className="next-icon mt-md-2" />
                        </div>
                    </div> */}
                </div>
            </div>

        </>
    )
}

export default YachtCard